/* eslint arrow-body-style: */
import { SHOW_PRODUCT_MODAL, HIDE_PRODUCT_MODAL } from './constants';

/**
 * Show the product modal
 * @param {number} productId
 */
const showProductModal = (productId, productSku) => ({
	type: SHOW_PRODUCT_MODAL,
	productId,
	productSku,
});

/**
 * Hide the product modal
 */
const hideProductModal = () => ({
	type: HIDE_PRODUCT_MODAL,
});

export {
	showProductModal,
	hideProductModal,
};
